var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookLogoV2 = function SvgFacebookLogoV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    d: "M12 1.5c5.8 0 10.5 4.729 10.5 10.564 0 5.274-3.84 9.644-8.86 10.436v-7.382h2.447l.466-3.054H13.64v-1.98c0-.836.406-1.651 1.71-1.651h1.325v-2.6s-1.202-.206-2.35-.206c-2.4 0-3.967 1.462-3.967 4.11v2.327H7.693v3.054h2.666V22.5C5.34 21.708 1.5 17.338 1.5 12.064 1.5 6.229 6.2 1.5 12 1.5"
  })));
};
export default SvgFacebookLogoV2;